export default __webpack_public_path__ + "static/media/discoverlogo.2f3106d4.gif";